export const formatLabel = (label: string | string[]) => (Array.isArray(label) ? label.join(' ') : label);
